import ActionDelete from '@/components/action-button/delete';
import ActionUpdate from '@/components/action-button/update';
import { convertNumberToCurrency } from '@/utility/helper/common';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@rrexpress/core';

export function ParcelTable(props: Partial<{
  data: Package[],
  onRemove: (index: number) => void,
  onUpdate: (record: Package, index: number) => void,
  readOnly: boolean,
  availableService: any[]
}>) {
  const isInAvailableService = (id: string) => (
    (props.availableService || [])
      .find((val) => val.product_service_id === id)
  );

  return (
    <Table className="!table">
      <TableHead>
        <TableRow>
          <TableCell>No</TableCell>
          <TableCell>Jenis Barang</TableCell>
          <TableCell>Deskripsi Barang</TableCell>
          <TableCell>Berat</TableCell>
          <TableCell>Harga Barang</TableCell>
          <TableCell>Asuransi</TableCell>
          <TableCell>Jenis Layanan</TableCell>
          <TableCell>Ongkir</TableCell>
          {!props.readOnly && (
            <TableCell>&nbsp;</TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {(props.data || []).map((item: Package, index: any) => (
          <TableRow
            style={!isInAvailableService(item?.product_service_id)
              ? { background: 'rgb(239, 68, 68)' }
              : {}
            }
          >
            <TableCell>{index + 1}</TableCell>
            <TableCell>{item.parcel_type_name}</TableCell>
            <TableCell>{item.parcel_description}</TableCell>
            <TableCell>{`${item.parcel_weight} Kg`}</TableCell>
            <TableCell>{convertNumberToCurrency(item.parcel_value)}</TableCell>
            <TableCell>{item.is_insurance ? 'YES' : 'NO'}</TableCell>
            <TableCell>
              <div className="grid grid-cols-2">
                <div className="text-center">
                  {item.product_service_code}
                </div>
                {!isInAvailableService(item?.product_service_id) && (
                  <Tooltip
                    direction="top"
                    tooltipContent="Jenis layanan tidak didukung"
                  >
                    <sup className="text-md text-black font-extrabold">
                      &#9432;
                    </sup>
                  </Tooltip>
                )}
              </div>
            </TableCell>
            <TableCell>{convertNumberToCurrency(item.shipping_price)}</TableCell>
            {!props.readOnly && (
              <TableCell>
                <div className="flex">
                  <div className="mr-2">
                    <ActionUpdate
                      onClick={() => {
                        props.onUpdate?.(item, index);
                      }}
                    />
                  </div>
                  <div>
                    <ActionDelete
                      onClick={() => {
                        props.onRemove?.(index);
                      }}
                    />
                  </div>
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ParcelTable;
